import request from '@/utils/request';

/**导出提成报表 */
export const comissionExport = function (formData?: any) {
    let url = '/api/Report/RechargeCommission';
    return request.download(url, { ...formData })
}

/**导出订单提成报表 */
export const goodExport = function (formData?: any) {
    let url = '/api/Report/OrderCommission';
    return request.download(url, { ...formData })
}

// 导出库存明细报表
export const stockExport = function (formData?: any) {
  return request.download('/api/Report/StockReport', { ...formData })
}